import PropTypes from "prop-types";
import React from "react";
import {Tab, Tabs} from "@mui/material";
import TabBarBase from "../../../../lib/components/tabbar/TabBarBase";
import VerticalLayout from "../../../../lib/components/layouts/VerticalLayout";
import HorizontalLayout from "../../../../lib/components/layouts/HorizontalLayout";

class HorizontalTabBar extends TabBarBase {

  render() {
    let tabs = this.state.tabs.map((tab) => (<Tab key={tab.id}
                                                  selected={tab.id === this.state.activeTabId}
                                                  component={() => React.cloneElement(tab.tab, {
                                                    id: tab.id,
                                                    activeTabId: this.state.activeTabId,
                                                    onTabClick: (id) => this.onTabClick(id),
                                                    onRemoveClick: (id) => this.onRemoveClick(id)
                                                  })}/>));

    let contents = this.state.tabs.map((tab) => (<div className='w-full'
                                                      key={tab.id}
                                                      style={{display: tab.id === this.state.activeTabId ? '' : 'none'}}>
      {React.cloneElement(tab.tabContent, {id: tab.id, activeTabId: this.state.activeTabId, onRemoveClick: (id) => this.onRemoveClick(id)})}
    </div>));

    return <VerticalLayout className={'CNINFO-HorizontalTabBar ' + this.props.className}>
      <HorizontalLayout>
        <Tabs value={this.getArrayTabIndex(this.state.activeTabId)}>
          {tabs}
        </Tabs>
      </HorizontalLayout>
      <HorizontalLayout className='overflow-y-scroll'>
        {contents}
      </HorizontalLayout>
    </VerticalLayout>;
  }
}

HorizontalTabBar.propTypes = {
  className: PropTypes.string
};
export default HorizontalTabBar;
